import { userService } from "../services";
import config from "../config/config";

export const SummaryAction = {
  FetchSummaryList,
  FetchUserList,
  fetchTeamList,
  getExportSummaryRportExcelBlob,
  getExportEmpWiseRportExcelBlob,
  getVendorListForDropDown,
  fetchDefaultMeetingDetails,
};

async function FetchSummaryList(payload) {
  try {
    // let apiEndpoint = ``
    //staticAPI

    // let apiEndpoint = `${config.baseUrl}${config.apiName.summaryReport}${payload.fromDate}/${payload.toDate}/${payload.employeeId}/${payload.hrmsUserId}`
    let apiEndpoint = `${config.baseUrl}${config.apiName.summaryReport}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function FetchUserList(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.userList}/${
      payload.hrmsUserId
    }/${payload.userId}${payload?.siteId ? `/${payload?.siteId}` : ""}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchTeamList(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.TeamList}/${payload?.hrmsCompanyId}?siteId=${payload?.siteId ? payload.siteId : ""}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function getExportSummaryRportExcelBlob(payload) {
  try {
    // let apiEndpoint = ``
    //staticAPI

    // let apiEndpoint = `${config.baseUrl}${config.apiName.summaryReport}${payload.fromDate}/${payload.toDate}/${payload.employeeId}/${payload.hrmsUserId}`
    let apiEndpoint = `${config.baseUrl}${config.apiName.exportSummaryRportExcelBlob}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function getExportEmpWiseRportExcelBlob(payload) {
  try {
    // let apiEndpoint = ``
    //staticAPI

    // let apiEndpoint = `${config.baseUrl}${config.apiName.summaryReport}${payload.fromDate}/${payload.toDate}/${payload.employeeId}/${payload.hrmsUserId}`
    let apiEndpoint = `${config.baseUrl}${config.apiName.exportEmpWiseReportExcelBlob}`;
    const response = await userService.post(apiEndpoint, payload);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function getVendorListForDropDown(payload) {
  const apiEndpoint = buildUrl(
    `${config.baseUrl}${config.apiName.getVendorListForDropDown}`,
    payload,
  );
  const response = await userService.get(apiEndpoint);
  if (response.status === 200) {
    return response.data;
  } else {
    return null;
  }
}

async function fetchDefaultMeetingDetails(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.defaultMeetingVisitDetails}/${payload?.locationVisitId}`;
    const response = await userService.get(apiEndpoint);
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

function buildUrl(baseUrl, params) {
  const url = new URL(baseUrl);

  // Filter and append valid params
  Object.entries(params).forEach(([key, value]) => {
    if (value != null) {
      url.searchParams.append(key, value);
    }
  });

  return url.toString();
}
